import React, {useState} from 'react';
import {useContext} from 'react';
import StarRatingComponent from 'react-star-rating-component';
import {Flex, Box} from 'reflexbox';
import FlightDetails from '../FlightDetails/FlightDetails';
import Iframe from 'react-iframe'
import './Hotel.scss'
import {DateTime} from 'luxon';
import Numberformat from 'react-number-format';
import {StoreContext} from "../../helpers/StoreContext";
import Loader from "../Loader/Loader";

export default (props)=> {
  // @see src/stores/HotelStore.js setHotels if you want to modify/set data for testing (or bugfixing).

  const [showDetails, setShowDetails] = useState(false);
  const [hibLink, setHibLink] = useState(undefined);
  const [vacancyLoading, setVacancyLoading] = useState(false);

  const rootStore = useContext(StoreContext);
  const hotelStore = rootStore.hotelStore;

  const offer = props.offer;

  if (offer.offer.id){
//    offer.offer.deviceTimes = undefined;
    const organizerImage = offer.offer.organizerImage;
    const arrivalDate = new DateTime.fromSeconds(offer.offer.arrivalDate).setLocale('de');
    const departureDate = new DateTime.fromSeconds(offer.offer.departureDate).setLocale('de');
    const duration = offer.offer.duration;
    const departureAirport = offer.offer.deviceTimes !== undefined && offer.offer.deviceTimes.outbound !== null && offer.offer.deviceTimes.outbound.length > 0 ? offer.offer.deviceTimes.outbound[0].departure.airport : null;
    const accommodation = offer.offer.accommodation;
    const catering = offer.offer.catering;
    const transfer = offer.offer.transfer === true ? 'inklusive Hoteltransfer' : 'Ohne Hoteltransfer';
    const currency = offer.offer.currency === 'EUR' ? '€' : offer.offer.currency;
    const bookingHint = offer.offer.bookingHint || '';
    const alternativeHint = offer.offer.alternativeHint || '';
    const iFrameStyles = {
      width: window.innerWidth*0.8,
      height: window.innerHeight*0.8,
    };

    let defVal = parseInt(offer.offer.timeOfVacancy);

    if (offer.vacancyCheckDate) {
      defVal = offer.vacancyCheckDate;
    }

    const validUntil  = DateTime.fromSeconds(defVal).plus({minutes: process.env.REACT_APP_VACANCY_VALID_UNTIL});

    let vacanyOutOfTime;
    if (validUntil < DateTime.local()) {
      vacanyOutOfTime = true;
    } else {
      vacanyOutOfTime = false;
    }

    const checkOffer = (index) => {
      hotelStore.updateHotel(index);
    }

    const urlParamsToObject = (params) => {
      if (params){
        const list = params.split('&').map((value, index) => {
          const data = value.split('=');
          return [data[0], data[1]];
        });
        const map = new Map(list);
        const entries  = Object.fromEntries(map);
        return entries;
      }
      return {};
    };

    const getBaliIbeUrl = (offer) => {
      const needed = urlParamsToObject(offer.searchParams);
      const baseUrl = process.env.REACT_APP_PORTAL_URL_NEW + process.env.REACT_APP_PORTAL_HOTEL + '/hotel/' + needed['giataId'] + '-giata/offers?';
      delete(needed['giataId']);

      let params = '';
      for(var key in needed){
        if (key.substring(0, 2) !== '__' && needed[key] !== ''){
          params += '&' + key + '=' + encodeURIComponent(needed[key]);
        }
      }
      if (needed.__seti) {
        params += '&custom_campaign=lta_' + offer._ltaId + '_' + needed.__seti;
      }
      return baseUrl + params.substring(1, params.length);
    };

    const getIbeUrl = (offer) => {
      if (offer.searchParams.indexOf('depDate') === -1) {
        return getBaliIbeUrl(offer);
      }
      const baseUrl = process.env.REACT_APP_PORTAL_URL + "/iberl/offers";

      let params = '';
      const needed = urlParamsToObject(offer.searchParams);
      for(var key in needed){
        if (needed[key] !== ''){
          params += '/' + key + '/' + encodeURIComponent(needed[key]);
        }
      }
      return baseUrl + params;
    };

    const getBookingUrl = (offer) => {
      const baseUrl = process.env.REACT_APP_PORTAL_URL + "/nsibe/booking/booking/key/";

      if (offer.bookingKeySessionless) {
        return baseUrl + offer.bookingKeySessionless;
      } else {
        return getIbeUrl(offer);
      }
    }

    const travellerToRender = (offer) => {
      var traveller = offer.offer.adults + ' Erwachsene' + (offer.offer.adults === 1 ? 'r' : '');

      if (offer.offer.children >= 1) {
        traveller = traveller + ', ' + offer.offer.children + ' Kind' +(offer.offer.children > 1 ? 'er' : '');
      }

      return traveller;
    };

    const soldOutClass = (offer) => {
      return (offer.vacancyStatus === "unavailable" ? 'sold-out' : '');
    };

    const formatNumber = (number) => {
      return <Numberformat value={number} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={2} fixedDecimalScale={2}/>
    }

    // disable loader
    if (vacanyOutOfTime === false
        && offer.vacancyStatus !== "in-progress"
        && vacancyLoading
    ) {
      setVacancyLoading(false);
    } else if (vacancyLoading === false
        && offer.vacancyStatus === "in-progress"
    ) {
        setVacancyLoading(true);
    }

    const durationText = duration > 1 ? `${duration + 1} Tage | ${duration} Nächte` :
      (duration === 1 ? `${duration + 1} Tage | ${duration} Nacht` : "");
    const propsToRender = [
      {
        // date
        icon:  (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 15.5C12.366 15.5 15.5 12.366 15.5 8.5C15.5 4.63401 12.366 1.5 8.5 1.5C4.63401 1.5 1.5 4.63401 1.5 8.5C1.5 12.366 4.63401 15.5 8.5 15.5Z" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.5 4.5V8.5H12.5" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>),
        value: (
          <div>
            <div>{arrivalDate.toLocaleString()} - {departureDate.toLocaleString()}</div>
            <div>{durationText}</div>
            { departureAirport === null ?  (null) : (<button className="flightdetails" onClick={() => {setShowDetails(!showDetails)}}>Alle Flugdetails <span className={"icon icon-arrow-bold-down" + (showDetails ? " up" : "")}></span></button>)}
            {showDetails ? <FlightDetails flightDetails={offer.offer.deviceTimes}/> : (null)}

          </div>)
      },
      departureAirport ?
      {
        // flight
        icon: (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.83012 10.202L1.16112 10.003C0.580118 9.95798 0.257118 10.66 0.669118 11.072L2.41912 12.805L3.83012 10.202Z" fill="#2A4D8F"/>
            <path d="M5.79807 12.17L5.99707 14.839C6.04207 15.42 5.34007 15.743 4.92807 15.331L3.19507 13.581L5.79807 12.17Z" fill="#2A4D8F"/>
            <path d="M9.04817 3.97097L4.19617 0.735974C3.63917 0.363974 2.89617 0.437974 2.42317 0.911974L0.753174 2.58197L6.56417 6.45597" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.0292 6.95203L15.2642 11.804C15.6362 12.361 15.5622 13.104 15.0882 13.577L13.4182 15.247L9.54517 9.43603" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.012 10.97L1.5 14.5L5.03 7.98801L11.901 1.11701C12.724 0.294006 14.059 0.294006 14.882 1.11701C15.705 1.94001 15.705 3.27501 14.882 4.09801L8.012 10.97Z" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>),
        value: "Flug ab " + departureAirport.name + " (" + departureAirport.code + ")"
      } : {},
      {
        // accommodation
        icon: (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.5 9.5H15.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2.5 6.5H13.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13.5 6.5V2.5H2.5V6.5L0.5 9.5V12.5H15.5V9.5L13.5 6.5Z" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M0.5 14.5V12.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M15.5 14.5V12.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>),
        value: accommodation,
        width: 0.7
      },
      {
        // catering
        icon: (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5 0.5V15.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14.5 10.5H10.5V4.5C10.5 3.43913 10.9214 2.42172 11.6716 1.67157C12.4217 0.921427 13.4391 0.5 14.5 0.5V0.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.5 8.5V15.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7.5 0.5V5.5C7.5 6.29565 7.18393 7.05871 6.62132 7.62132C6.05871 8.18393 5.29565 8.5 4.5 8.5V8.5C3.70435 8.5 2.94129 8.18393 2.37868 7.62132C1.81607 7.05871 1.5 6.29565 1.5 5.5V0.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.5 0.5V5.5" stroke="#2A4D8F" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>),
        value: catering,
        width: 0.7
      },
      {
        // transfer
        icon: (
            offer.offer.transfer === true ?
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5 0.5L15.5 4.5L11.5 8.5" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M0.5 4.5H15.5" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.5 7.5L0.5 11.5L4.5 15.5" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M15.5 11.5H0.5" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
          :
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2.69702 13.303L13.303 2.69702" stroke="#2A4D8F" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
        ),
        value: transfer,
        width: 0.7
      }];

    const renderValues = propsToRender.map((entry, index) => {
        return(<Flex flexWrap='wrap' key={index}>
          <Box className='detail-icon'  width={0.1}>
            {entry.icon}
          </Box>
          <Box flex='1' flexGrow={entry.width !== undefined ? entry.width : 1} className="details">{entry.value}</Box>
        </Flex>);
      });

    if (offer.offer.price > 1000000) {
      offer.vacancyStatus = "unavailable";
    }

    // ---------- RENDERING STARTS HERE ----------
    return (
      <div>
      <Flex className={'hotel-offer ' + (soldOutClass(offer))} flexDirection='column' >
          <Box className={"hotel-loading-overlay " + (vacancyLoading ? "active" : "")}>
              <Loader size="large" />
          </Box>
        <Box
          className={'head' + (offer.highlight ? ' head--recommended' : '')}>
          <Flex justifyContent='space-between'>
            <Box>{offer.highlight ? 'Empfohlenes ' : ''} Angebot Nr. {props.index + 1}</Box>
            <Box>{departureAirport === null ? 'nur Hotel' : 'Pauschal'}</Box>
          </Flex>
        </Box>
        <Box className='image'>
          <div><img src={offer.hotel.images[0]} alt="" className={'image ' + (soldOutClass(offer))}/></div>
        </Box>
        <Box className='body'>
          <div className="offer">
            <div className="offerDetails">
              <StarRatingComponent
                className='icon'
                name='category' /* name of the radio input, it is required */
                value={offer.hotel.category} /* number of selected icon (`0` - none, `1` - first) */
                starCount={6} /* number of icons in rating, default `5` */
                starColor='#ff9d28' /* color of selected icons, default `#ffb400` */
                emptyStarColor='#ffffff'
                editing={false} /* is component available for editing, default `true` */
                renderStarIcon={(index, value) =>
                  {
                    if (index <= value){
                      return (<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M16.3935 5.56501L11.3786 4.84639L9.13465 0.361314C9.00237 0.137574 8.75964 0 8.49717 0C8.23469 0 7.99196 0.137574 7.85968 0.361314L5.62141 4.84639L0.606543 5.56501C0.339663 5.60326 0.117945 5.78776 0.0346517 6.0409C-0.0486413 6.29404 0.0209439 6.57189 0.214137 6.75759L3.84354 10.2528L2.98506 15.1825C2.93934 15.4449 3.04868 15.7102 3.26704 15.8667C3.4854 16.0231 3.77486 16.0435 4.01354 15.9193L8.5 13.5873L12.9865 15.9151C13.0876 15.9681 13.2006 15.9955 13.3151 15.9948C13.5241 15.9952 13.7225 15.9046 13.8575 15.7472C13.9924 15.5898 14.05 15.3816 14.0149 15.1783L13.1565 10.2486L16.7859 6.75339C16.9791 6.5677 17.0486 6.28984 16.9653 6.0367C16.8821 5.78357 16.6603 5.59907 16.3935 5.56082V5.56501Z" fill="#FFA404"/></svg>)
                    }else{
                      return (null);
                    }
                  }
                }
              />
            </div>
            <h2 className='name'>{offer.hotel.name}</h2>
            <h3>{offer.hotel.address}</h3>
            <hr/>
            {renderValues}
            <div className="operator">
              <Flex flexDirection="column">
                <Box>
                  <img src={organizerImage} alt="Veranstalter" className={'image ' + (soldOutClass(offer))} />
                </Box>
                <Box>
                  <a href={offer.offer.hibLink} onClick={(e) => {setHibLink(offer.offer.hibLink); e.preventDefault()}} target='_blank' rel='noopener noreferrer'>weitere Infos</a>
                </Box>
              </Flex>
            </div>
          </div>
          <Flex flexWrap='wrap' className="hotel-offer-divider">
            {offer.vacancyStatus !== "unavailable" ? ([
                <Box className='info' key={"0"}>
                  <strong>Gesamtpreis:</strong><br/>
                  {travellerToRender(offer)}
                </Box>,
                <Box flex='1'  key={"1"+offer.offer.price}>
                  <div className='price'>{formatNumber(offer.offer.price)} {currency}</div>
                </Box>,

            ]) : null
            }

              {vacanyOutOfTime === false && offer.vacancyStatus === "in-progress" ? (
                  <Box width={1} mt={15} key={"1"+offer.offer.hibLink}>
                      <a href={getIbeUrl(offer)} target='_blank' className="button hotel-button" rel='noopener noreferrer'>Angebot wird geprüft</a>
                  </Box>
                  )  :
                      (vacanyOutOfTime === false && offer.vacancyStatus === "available" ?
                          (bookingHint !== '' ?
                           <div className="no-vacancy">{bookingHint}</div>
                          : (
                      <Box width={1} mt={15} key={"1"+offer.offer.hibLink}>
                        <a href={getBookingUrl(offer)} target='_blank' className="button hotel-button" rel='noopener noreferrer'>Zur Buchung</a>
                      </Box>
                    )
                              ) :
                      (vacanyOutOfTime && offer.vacancyStatus === "available" ?
                          <Box width={1} mt={15} key={"1"+offer.offer.hibLink}>
                            <a onClick={(e) => {checkOffer(props.index); setVacancyLoading(true); e.preventDefault()}} href={getIbeUrl(offer)} target='_blank' className="button hotel-button" rel='noopener noreferrer'>Angebot prüfen</a>
                          </Box>
                         :
                            (alternativeHint !== '' ?
                              <div className="no-vacancy"><div>Angebot nicht mehr verfügbar</div>{alternativeHint}</div>
                              :
                              <div className="no-vacancy"><div>Angebot nicht mehr verfügbar</div><a href={getIbeUrl(offer)} target="alternatives" className="button hotel-button">Alternativen prüfen</a></div>
                          )
                      )
                  )
              }
              </Flex>
        </Box>
        {offer.vacancy === "no-vacancy" ? <div className="aperture"></div> : (null)}

      </Flex>
        {hibLink ? (<div className="hibFrame" style={iFrameStyles}>
          <button className="close icon-close" onClick={() =>{
            setHibLink(undefined);
          }}></button>
          <Iframe
            frameBorder = "0"
            position="absolute"
            width={(window.innerWidth  * 0.8)+"px"}
            height={(window.innerHeight  * 0.8)+"px"}
            url = {hibLink}></Iframe>

        </div>) : (null)}
      </div>)
  }else{
    return (null);
  }
}
